/**
 * Logger utility that only logs in development mode
 * This helps prevent sensitive information from being logged in production
 * while maintaining helpful debug logs during development
 */

/**
 * Log messages to console in development mode only
 * @param args - Arguments to log (same as console.log)
 */
export const log = (...args: any[]): void => {
  if (process.env.REACT_APP_ENV === 'dev') {
    console.log(...args);
  }
};

/**
 * Log warning messages to console in development mode only
 * @param args - Arguments to log (same as console.warn)
 */
export const warn = (...args: any[]): void => {
  if (process.env.REACT_APP_ENV === 'dev') {
    console.warn(...args);
  }
};

/**
 * Log error messages to console in all environments
 * Errors should always be logged for monitoring purposes
 * @param args - Arguments to log (same as console.error)
*/
export const error = (...args: any[]): void => {
  console.error(...args);
};

/**
 * Log info messages to console in development mode only
 * @param args - Arguments to log (same as console.info)
*/
export const info = (...args: any[]): void => {
  if (process.env.REACT_APP_ENV === 'dev') {
    console.info(...args);
  }
};

/**
 * Log debug messages to console in development mode only
 * @param args - Arguments to log (same as console.debug)
 */
export const debug = (...args: any[]): void => {
  if (process.env.REACT_APP_ENV === 'dev') {
    console.debug(...args);
  }
};

/**
 * Measure time between operations in development mode only
 * @param label - Label for the timer
 */
export const time = (label: string): void => {
  if (process.env.REACT_APP_ENV === 'dev') {
    console.time(label);
  }
};

/**
 * End timer and log elapsed time in development mode only
 * @param label - Label for the timer
*/
export const timeEnd = (label: string): void => {
  if (process.env.REACT_APP_ENV === 'dev') {
    console.timeEnd(label);
  }
};